import React, {useEffect, useRef, useState} from "react";
import Header from "../components/Header.js";
import BackButton from "../components/BackButton.js";
import StandardReportsForm from "../components/StandardReportsForm.js";
import StandardReportsService from "../services/standardreports.sevice.js";
import ReactTable from "../components/ReactTable/ReactTable.js";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleNotch, faExclamationTriangle,} from "@fortawesome/free-solid-svg-icons";
import GeneralService from "../services/general.service.js";
import {exportCsv} from "../_helpers/makeCsv.js";
import generatePrintFriendlyTable from "../_helpers/generatePrintFriendlyTable.js";
import {toast} from "react-toastify";
import {faMagnifyingGlassMinus} from "@fortawesome/free-solid-svg-icons/faMagnifyingGlassMinus";

function ExtractWorkSitePage(props) {
  let reportTitle = "Extract for Site of Work";
  let reportInfo =
    "Produce an Extract for Site of Work.";

  let fields = [
    { name: "route", required: true },
    { name: "elr", required: true },
    { name: "mileage", required: false },
  ];

  const [values, setValues] = useState();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [customSearchItems, setCustomSearchItems] = useState();
  const [filteredElr, setFilteredElr] = useState();
  const [error, setError] = useState(null);
  const routeSelectInput = useRef(null);
  const elrSelectInput = useRef(null);
  const startMileageSelectInput = useRef(null);
  const endMileageSelectInput = useRef(null);
  const [fieldsErrors, setFieldsErrors] = useState();
  const [loading, setLoading] = useState(false);
  const [reset, setReset] = useState(false);

  useEffect(() => {
    setCustomSearchItems((old) => ({
      ...old,
      status: {
        loading: false,
        error: false,
      },
    }));
  }, [values]);

  //fetch ElRs based on route
  useEffect(() => {
    if (values?.route) {
      setFilteredElr(["loading..."]);
      setValues((values) => ({
        ...values,
        elr: "",
        mdu: "",
      }));
      GeneralService.getElrsZonecode(null, values?.route?.zonecode)
        .then((response) => {
          setFilteredElr(response.data.results);
        })
        .catch((error) => {
          setFilteredElr();
        });
    } else {
      setFilteredElr();
    }
  }, [values?.route]);

  const handleInputChange = (e) => {
    if (e.target.name === "startMileage") {
      if (
        values?.elr?.startmiles &&
        values?.elr?.endmiles &&
        e.target.value &&
        (parseFloat(e.target.value) < values?.elr?.startmiles ||
          parseFloat(e.target.value) > values?.elr?.endmiles)
      ) {
        e.target.setCustomValidity(
          `The value range needs to be between ${values?.elr?.startmiles} and ${values?.elr?.endmiles}`
        );
        e.target.reportValidity();
        setFieldsErrors((old) => ({ ...old, [e.target.name]: "Error" }));
      } else {
        e.target.setCustomValidity("");
        setFieldsErrors((old) => ({ ...old, [e.target.name]: undefined }));
      }
    }
    if (e.target.name === "endMileage") {
      if (
        values?.elr?.startmiles &&
        values?.elr?.endmiles &&
        e.target.value &&
        (parseFloat(e.target.value) < parseFloat(values?.elr?.startmiles) ||
        parseFloat(e.target.value) > parseFloat(values?.elr?.endmiles))
      ) {
        e.target.setCustomValidity(
          `The value range needs to be between ${values?.elr?.startmiles} and ${values?.elr?.endmiles}`
        );
        e.target.reportValidity();
        setFieldsErrors((old) => ({ ...old, [e.target.name]: "Error" }));
      } else {
        e.target.setCustomValidity("");
        setFieldsErrors((old) => ({ ...old, [e.target.name]: undefined }));
      }
    }

    setValues((values) => ({ ...values, [e.target.name]: e.target.value }));
  };

  useEffect(() => {

  }, [values]);

  const handlePageSize = (val) => {
    setPage(0);
    setPageSize(val);
  };

  const handleReset = () => {
    setReset(true);
    setCustomSearchItems({
      status: {
        loading: false,
        error: false,
      },
    });
  }

  function handleSubmit(pageVal, pageSizeVal) {
    setReset();
    let validRoute = routeSelectInput.current.validateField();
    let validElr = elrSelectInput.current.validateField();

    let validStartMileage = startMileageSelectInput.current.validateField();
    let validEndMileage = endMileageSelectInput.current.validateField();
    // let validType = elrSelectInput.current.validateField();
    if (validRoute && validElr && validStartMileage && validEndMileage) {
      setCustomSearchItems({
        status: {
          loading: true,
          error: false,
        },
      });
      let pageNumber = pageVal === 0 ? 0 : pageVal || page || 0;
      let pageSizeNumber = pageSizeVal === 0 ? 0 : pageSizeVal || pageSize || 0;

      StandardReportsService.siteWork(pageNumber, pageSizeNumber, values)
        .then((response) => {
          setCustomSearchItems(response.data);
        })
        .catch((error) => {
          setCustomSearchItems({
            status: {
              loading: false,
              error: true,
            },
          });
        });
    } else {
      setLoading(false);
      setCustomSearchItems({
        status: {
          loading: false,
          error: "Please check the form is complete and required values are selected.",
        },
      });
    }
  }

  const handleExport = () => {
    StandardReportsService.siteWorkExport(page, pageSize, values)
      .then((response) => {
        toast.success(`Your Export has been sent and you will receive an email shortly with the attached report.`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      })
      .catch((error) => {});
  };

  return (
    <div className="page" id="extractWorkSitePage">
      <Header title="Extract for Site of Work" />
      <BackButton
        setPage={props.setPage}
        target={["standardReportsPage", "backward"]}
      />

      <StandardReportsForm
        data={props}
        reportTitle={reportTitle}
        reportInfo={reportInfo}
        fields={fields}
        filteredElr={filteredElr}
        handleSubmit={() => handleSubmit(0, undefined)}
        handleReset={() => handleReset()}
        values={values}
        setValues={setValues}
        routeSelectInput={routeSelectInput}
        elrSelectInput={elrSelectInput}
        startMileageSelectInput={startMileageSelectInput}
        endMileageSelectInput={endMileageSelectInput}
        fieldsErrors={fieldsErrors}
        setFieldsErrors={setFieldsErrors}
        loading={customSearchItems?.status?.loading}
        error={customSearchItems?.status?.error}
        handleInputChange={handleInputChange}
      />
      <div>
        {customSearchItems?.status?.loading === true && (
          <div className="loadingCircle">
            <FontAwesomeIcon icon={faCircleNotch} spin={true} />
          </div>
        )}
        {customSearchItems?.status?.error === true && (
          <div className="loadingCircle">
            Error fetching data
            <FontAwesomeIcon icon={faExclamationTriangle} />
          </div>
        )}
        {customSearchItems?.results && customSearchItems?.results?.length > 0 && (
          <ReactTable
            // hideColumns={["id"]}
            customSearch={true}
            showColumns={customSearchItems?.headers}
            customHeader={true}
            tableData={customSearchItems.results}
            currentPage={customSearchItems?.pageNumber}
            totalPages={customSearchItems?.totalPages}
            pageSize={customSearchItems?.pageSize}
            totalElements={customSearchItems?.totalElements}
            setPage={(val) => {
              setPage(val);
              handleSubmit(val, undefined);
            }}
            setPageSize={(val) => {
              handlePageSize(val);
              handleSubmit(0, val);
            }}
            exportCsv={{ name: "extractWorkSite", action: handleExport }}
          ></ReactTable>
        )}
        {customSearchItems?.results && customSearchItems?.results.length === 0 && !reset && (
            <div className="loadingCircle">
              No Results Based On Your Search Criteria
              <span style={{marginLeft: "10px"}}> <FontAwesomeIcon icon={faMagnifyingGlassMinus}/> </span>
            </div>
        )}
      </div>
    </div>
  );
}

export default ExtractWorkSitePage;
